import { useDropzone } from 'react-dropzone';
import { useSnackBars } from '@contexts/Snackbar/SnackBarContext';

export function useUploadFile({
  configUseDropeZone,
  setFileRejections,
  setFiles,
  textShowErrorSnackbar = 'Solo se aceptan archivos: jpeg, jpg, png, pdf, doc, docx',
}) {
  const { showErrorSnackbar } = useSnackBars();
  const multipleFiles = configUseDropeZone?.maxFiles != 1;

  const { getRootProps, getInputProps, isDragReject } = useDropzone({
    ...configUseDropeZone,
    noDragEventsBubbling: true,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setFileRejections &&
        rejectedFiles?.length > 0 &&
        setFileRejections(rejectedFiles);

      if (isDragReject) {
        showErrorSnackbar(textShowErrorSnackbar);
      }
      if (acceptedFiles && acceptedFiles.length > 0) {
        if (multipleFiles) {
          setFiles((prevFiles) => {
            let paths = new Set(prevFiles.map((f) => f.path));
            let merged = [
              ...prevFiles,
              ...acceptedFiles.filter((f) => !paths.has(f.path)),
            ];
            return prevFiles ? merged : acceptedFiles;
          });
        } else {
          setFiles(acceptedFiles);
        }
      }
    },
  });

  return {
    getRootProps,
    getInputProps,
  };
}
